export const workoutCodeDemo = {
    "title": "Workout Demo",
    "publish": "2022-02-08",
    "video_code": "IN000_L00V01_N^_T00;#PB000_L00V01_N05_T00,BI000_L00V01_N05_T00,DU030_L01V01_N05_T00,MN001_L^V01_N^_T00,MN004_L^V01_N^_T00,MN021_L^V02_N^_T00,RD003_L00V01_N00_T00;MT001_L^V01_N^_T30;UN004_L^V00_N^_T15,MT004_L^V01_N^_T30;UN021_L^V00_N^_T15,MT021_L^V01_N^_T30;NR002_L00V00_N^_T00;UN001_L^V00_N^_T15,MT001_L^V02_N^_T30;UN004_L^V00_N^_T15,MT004_L^V02_N^_T30;UN021_L^V00_N^_T15,MT021_L^V02_N^_T30;NR003_L00V00_N^_T00;UN001_L^V00_N^_T15,MT001_L^V03_N^_T30;UN004_L^V00_N^_T15,MT004_L^V03_N^_T30;UN021_L^V00_N^_T15,MT021_L^V03_N^_T30;#OT000_L00V01_N^_T00;",
    "video_iterations": "{\"IN000_L00V01_N^_T00\": \"IN000_L00V01_N05_T00\", \"PB000_L00V01_N05_T00\": \"PB000_L00V01_N05_T00\", \"BI000_L00V01_N05_T00\": \"BI000_L00V01_N05_T00\", \"DU030_L01V01_N05_T00\": \"DU030_L01V01_N05_T00\", \"RD003_L00V01_N00_T00\": \"RD003_L00V01_N05_T00\", \"MN001_L01V01_N^_T00\": \"MN001_L01V01_N05_T00\", \"MN001_L02V01_N^_T00\": \"MN001_L02V01_N05_T00\", \"MN001_L03V01_N^_T00\": \"MN001_L03V01_N05_T00\", \"MN001_L04V01_N^_T00\": \"MN001_L04V01_N05_T00\", \"MN001_L05V01_N^_T00\": \"MN001_L05V01_N05_T00\", \"MN001_L06V01_N^_T00\": \"MN001_L06V01_N05_T00\", \"MN001_L07V01_N^_T00\": \"MN001_L07V01_N05_T00\", \"MN001_L08V01_N^_T00\": \"MN001_L08V01_N05_T00\", \"MN004_L01V01_N^_T00\": \"MN004_L01V01_N05_T00\", \"MN004_L02V01_N^_T00\": \"MN004_L02V01_N05_T00\", \"MN004_L03V01_N^_T00\": \"MN004_L03V01_N05_T00\", \"MN004_L04V01_N^_T00\": \"MN004_L04V01_N05_T00\", \"MN004_L05V01_N^_T00\": \"MN004_L05V01_N05_T00\", \"MN004_L06V01_N^_T00\": \"MN004_L06V01_N05_T00\", \"MN004_L07V01_N^_T00\": \"MN004_L07V01_N05_T00\", \"MN004_L08V01_N^_T00\": \"MN004_L08V01_N05_T00\", \"MN004_L09V01_N^_T00\": \"MN004_L09V01_N05_T00\", \"MN021_L01V02_N^_T00\": \"MN021_L01V02_N05_T00\", \"MN021_L02V02_N^_T00\": \"MN021_L02V02_N05_T00\", \"MN021_L03V02_N^_T00\": \"MN021_L03V02_N05_T00\", \"MN021_L04V02_N^_T00\": \"MN021_L04V02_N05_T00\", \"MN021_L05V02_N^_T00\": \"MN021_L05V02_N05_T00\", \"MN021_L06V02_N^_T00\": \"MN021_L06V02_N05_T00\", \"MT001_L01V01_N^_T30\": \"MT001_L01V01_N06_T30\", \"MT001_L02V01_N^_T30\": \"MT001_L02V01_N06_T30\", \"MT001_L03V01_N^_T30\": \"MT001_L03V01_N06_T30\", \"MT001_L04V01_N^_T30\": \"MT001_L04V01_N06_T30\", \"MT001_L05V01_N^_T30\": \"MT001_L05V01_N06_T30\", \"MT001_L06V01_N^_T30\": \"MT001_L06V01_N06_T30\", \"MT001_L07V01_N^_T30\": \"MT001_L07V01_N06_T30\", \"MT001_L08V01_N^_T30\": \"MT001_L08V01_N06_T30\", \"UN004_L01V00_N^_T15\": \"UN004_L01V00_N05_T15\", \"MT004_L01V01_N^_T30\": \"MT004_L01V01_N06_T30\", \"UN004_L02V00_N^_T15\": \"UN004_L02V00_N05_T15\", \"MT004_L02V01_N^_T30\": \"MT004_L02V01_N06_T30\", \"UN004_L03V00_N^_T15\": \"UN004_L03V00_N05_T15\", \"MT004_L03V01_N^_T30\": \"MT004_L03V01_N06_T30\", \"UN004_L04V00_N^_T15\": \"UN004_L04V00_N05_T15\", \"MT004_L04V01_N^_T30\": \"MT004_L04V01_N06_T30\", \"UN004_L05V00_N^_T15\": \"UN004_L05V00_N05_T15\", \"MT004_L05V01_N^_T30\": \"MT004_L05V01_N06_T30\", \"UN004_L06V00_N^_T15\": \"UN004_L06V00_N05_T15\", \"MT004_L06V01_N^_T30\": \"MT004_L06V01_N06_T30\", \"UN004_L07V00_N^_T15\": \"UN004_L07V00_N05_T15\", \"MT004_L07V01_N^_T30\": \"MT004_L07V01_N06_T30\", \"UN004_L08V00_N^_T15\": \"UN004_L08V00_N05_T15\", \"MT004_L08V01_N^_T30\": \"MT004_L08V01_N06_T30\", \"UN004_L09V00_N^_T15\": \"UN004_L09V00_N05_T15\", \"MT004_L09V01_N^_T30\": \"MT004_L09V01_N06_T30\", \"UN021_L01V00_N^_T15\": \"UN021_L01V00_N05_T15\", \"MT021_L01V01_N^_T30\": \"MT021_L01V01_N06_T30\", \"UN021_L02V00_N^_T15\": \"UN021_L02V00_N05_T15\", \"MT021_L02V01_N^_T30\": \"MT021_L02V01_N06_T30\", \"UN021_L03V00_N^_T15\": \"UN021_L03V00_N05_T15\", \"MT021_L03V01_N^_T30\": \"MT021_L03V01_N06_T30\", \"UN021_L04V00_N^_T15\": \"UN021_L04V00_N05_T15\", \"MT021_L04V01_N^_T30\": \"MT021_L04V01_N06_T30\", \"UN021_L05V00_N^_T15\": \"UN021_L05V00_N05_T15\", \"MT021_L05V01_N^_T30\": \"MT021_L05V01_N06_T30\", \"UN021_L06V00_N^_T15\": \"UN021_L06V00_N05_T15\", \"MT021_L06V01_N^_T30\": \"MT021_L06V01_N06_T30\", \"NR002_L00V00_N^_T00\": \"NR002_L00V00_N05_T00\", \"UN001_L01V00_N^_T15\": \"UN001_L01V00_N05_T15\", \"MT001_L01V02_N^_T30\": \"MT001_L01V02_N06_T30\", \"UN001_L02V00_N^_T15\": \"UN001_L02V00_N05_T15\", \"MT001_L02V02_N^_T30\": \"MT001_L02V02_N06_T30\", \"UN001_L03V00_N^_T15\": \"UN001_L03V00_N05_T15\", \"MT001_L03V02_N^_T30\": \"MT001_L03V02_N06_T30\", \"UN001_L04V00_N^_T15\": \"UN001_L04V00_N05_T15\", \"MT001_L04V02_N^_T30\": \"MT001_L04V02_N06_T30\", \"UN001_L05V00_N^_T15\": \"UN001_L05V00_N05_T15\", \"MT001_L05V02_N^_T30\": \"MT001_L05V02_N06_T30\", \"UN001_L06V00_N^_T15\": \"UN001_L06V00_N05_T15\", \"MT001_L06V02_N^_T30\": \"MT001_L06V02_N06_T30\", \"UN001_L07V00_N^_T15\": \"UN001_L07V00_N05_T15\", \"MT001_L07V02_N^_T30\": \"MT001_L07V02_N06_T30\", \"UN001_L08V00_N^_T15\": \"UN001_L08V00_N05_T15\", \"MT001_L08V02_N^_T30\": \"MT001_L08V02_N06_T30\", \"MT004_L01V02_N^_T30\": \"MT004_L01V02_N01_T30\", \"MT004_L02V02_N^_T30\": \"MT004_L02V02_N01_T30\", \"MT004_L03V02_N^_T30\": \"MT004_L03V02_N01_T30\", \"MT004_L04V02_N^_T30\": \"MT004_L04V02_N01_T30\", \"MT004_L05V02_N^_T30\": \"MT004_L05V02_N01_T30\", \"MT004_L06V02_N^_T30\": \"MT004_L06V02_N01_T30\", \"MT004_L07V02_N^_T30\": \"MT004_L07V02_N01_T30\", \"MT004_L08V02_N^_T30\": \"MT004_L08V02_N01_T30\", \"MT004_L09V02_N^_T30\": \"MT004_L09V02_N01_T30\", \"MT021_L01V02_N^_T30\": \"MT021_L01V02_N06_T30\", \"MT021_L02V02_N^_T30\": \"MT021_L02V02_N06_T30\", \"MT021_L03V02_N^_T30\": \"MT021_L03V02_N06_T30\", \"MT021_L04V02_N^_T30\": \"MT021_L04V02_N06_T30\", \"MT021_L05V02_N^_T30\": \"MT021_L05V02_N06_T30\", \"MT021_L06V02_N^_T30\": \"MT021_L06V02_N06_T30\", \"NR003_L00V00_N^_T00\": \"NR003_L00V00_N05_T00\", \"MT001_L01V03_N^_T30\": \"MT001_L01V03_N06_T30\", \"MT001_L02V03_N^_T30\": \"MT001_L02V03_N06_T30\", \"MT001_L03V03_N^_T30\": \"MT001_L03V03_N06_T30\", \"MT001_L04V03_N^_T30\": \"MT001_L04V03_N06_T30\", \"MT001_L05V03_N^_T30\": \"MT001_L05V03_N06_T30\", \"MT001_L06V03_N^_T30\": \"MT001_L06V03_N06_T30\", \"MT001_L07V03_N^_T30\": \"MT001_L07V03_N06_T30\", \"MT001_L08V03_N^_T30\": \"MT001_L08V03_N06_T30\", \"MT004_L01V03_N^_T30\": \"MT004_L01V03_N06_T30\", \"MT004_L02V03_N^_T30\": \"MT004_L02V03_N06_T30\", \"MT004_L03V03_N^_T30\": \"MT004_L03V03_N06_T30\", \"MT004_L04V03_N^_T30\": \"MT004_L04V03_N06_T30\", \"MT004_L05V03_N^_T30\": \"MT004_L05V03_N06_T30\", \"MT004_L06V03_N^_T30\": \"MT004_L06V03_N06_T30\", \"MT004_L07V03_N^_T30\": \"MT004_L07V03_N06_T30\", \"MT004_L08V03_N^_T30\": \"MT004_L08V03_N06_T30\", \"MT004_L09V03_N^_T30\": \"MT004_L09V03_N06_T30\", \"MT021_L01V03_N^_T30\": \"MT021_L01V03_N06_T30\", \"MT021_L02V03_N^_T30\": \"MT021_L02V03_N06_T30\", \"MT021_L03V03_N^_T30\": \"MT021_L03V03_N06_T30\", \"MT021_L04V03_N^_T30\": \"MT021_L04V03_N06_T30\", \"MT021_L05V03_N^_T30\": \"MT021_L05V03_N06_T30\", \"MT021_L06V03_N^_T30\": \"MT021_L06V03_N06_T30\", \"OT000_L00V01_N^_T00\": \"OT000_L00V01_N05_T00\"}",
    "transcoded": false,
    "version": "V005",
    "total_time": "17:24",
    "assessment": false,
    "active_assessment": false,
    "description": "Today we are working on full body and core.",
    "desc_secondary": "You've got this!",
    "date_created": "2021-12-09 22:25:33.616167+00:00",
    "date_updated": "2022-02-04 20:02:19.479437+00:00"
}

export const movementList = {
    "WU": [
        {
            "category": "WU",
            "movement_type": "FULL",
            "name": "Bird Dog",
            "identifier": "027",
            "level": 3
        },
        {
            "category": "WU",
            "movement_type": "FULL",
            "name": "BOW AND ARROW (U)",
            "identifier": "032",
            "level": 3
        },
        {
            "category": "WU",
            "movement_type": "FULL",
            "name": "Deep Breathing",
            "identifier": "037",
            "level": 3
        },
        {
            "category": "WU",
            "movement_type": "FULL",
            "name": "Elevator",
            "identifier": "038",
            "level": 3
        },
        {
            "category": "WU",
            "movement_type": "FULL",
            "name": "Front Bends",
            "identifier": "012",
            "level": 3
        },
        {
            "category": "WU",
            "movement_type": "FULL",
            "name": "High Bear Hold",
            "identifier": "029",
            "level": 3
        },
        {
            "category": "WU",
            "movement_type": "FULL",
            "name": "Hollow Position",
            "identifier": "024",
            "level": 3
        },
        {
            "category": "WU",
            "movement_type": "FULL",
            "name": "JEFFERSON CURL",
            "identifier": "033",
            "level": 3
        },
        {
            "category": "WU",
            "movement_type": "FULL",
            "name": "Kneeling Back Bend",
            "identifier": "025",
            "level": 3
        },
        {
            "category": "WU",
            "movement_type": "FULL",
            "name": "Marching",
            "identifier": "026",
            "level": 3
        },
        {
            "category": "WU",
            "movement_type": "FULL",
            "name": "REVERSE TWISTING LUNGE",
            "identifier": "030",
            "level": 3
        },
        {
            "category": "WU",
            "movement_type": "FULL",
            "name": "Side Bends",
            "identifier": "011",
            "level": 3
        },
        {
            "category": "WU",
            "movement_type": "FULL",
            "name": "Side Plank (U)",
            "identifier": "028",
            "level": 3
        },
        {
            "category": "WU",
            "movement_type": "FULL",
            "name": "Spine Twist L",
            "identifier": "014",
            "level": 3
        },
        {
            "category": "WU",
            "movement_type": "FULL",
            "name": "Spine Twists R",
            "identifier": "013",
            "level": 3
        },
        {
            "category": "WU",
            "movement_type": "FULL",
            "name": "STANDING SIDE BENDS",
            "identifier": "031",
            "level": 3
        },
        {
            "category": "WU",
            "movement_type": "FULL",
            "name": "T PLANK",
            "identifier": "035",
            "level": 3
        },
        {
            "category": "WU",
            "movement_type": "FULL",
            "name": "TURKISH GET UP (U)",
            "identifier": "036",
            "level": 3
        },
        {
            "category": "WU",
            "movement_type": "LOWER",
            "name": "Calf Stretch L",
            "identifier": "002",
            "level": 3
        },
        {
            "category": "WU",
            "movement_type": "LOWER",
            "name": "Calf Stretch R",
            "identifier": "001",
            "level": 3
        },
        {
            "category": "WU",
            "movement_type": "LOWER",
            "name": "Glute Stretch L",
            "identifier": "010",
            "level": 3
        },
        {
            "category": "WU",
            "movement_type": "LOWER",
            "name": "Glute stretch R",
            "identifier": "009",
            "level": 3
        },
        {
            "category": "WU",
            "movement_type": "LOWER",
            "name": "Hamstring Stretch L",
            "identifier": "005",
            "level": 3
        },
        {
            "category": "WU",
            "movement_type": "LOWER",
            "name": "Hamstring Stretch R",
            "identifier": "004",
            "level": 3
        },
        {
            "category": "WU",
            "movement_type": "LOWER",
            "name": "Hip Flexor Stretch L",
            "identifier": "007",
            "level": 3
        },
        {
            "category": "WU",
            "movement_type": "LOWER",
            "name": "Hip Flexor Stretch R",
            "identifier": "006",
            "level": 3
        },
        {
            "category": "WU",
            "movement_type": "LOWER",
            "name": "Straddle Stretch",
            "identifier": "008",
            "level": 3
        },
        {
            "category": "WU",
            "movement_type": "LOWER",
            "name": "Tib Curls",
            "identifier": "003",
            "level": 3
        },
        {
            "category": "WU",
            "movement_type": "UPPER",
            "name": "Chest Stretch L",
            "identifier": "020",
            "level": 3
        },
        {
            "category": "WU",
            "movement_type": "UPPER",
            "name": "Chest Stretch R",
            "identifier": "019",
            "level": 3
        },
        {
            "category": "WU",
            "movement_type": "UPPER",
            "name": "Down Dog",
            "identifier": "015",
            "level": 3
        },
        {
            "category": "WU",
            "movement_type": "UPPER",
            "name": "Neck Loosener",
            "identifier": "021",
            "level": 3
        },
        {
            "category": "WU",
            "movement_type": "UPPER",
            "name": "Shoulder Stretch",
            "identifier": "018",
            "level": 3
        },
        {
            "category": "WU",
            "movement_type": "UPPER",
            "name": "Up Dog",
            "identifier": "016",
            "level": 3
        },
        {
            "category": "WU",
            "movement_type": "UPPER",
            "name": "Wrist Extension Stretch",
            "identifier": "023",
            "level": 3
        },
        {
            "category": "WU",
            "movement_type": "UPPER",
            "name": "Wrist Flexion Stretch",
            "identifier": "022",
            "level": 3
        },
        {
            "category": "WU",
            "movement_type": "UPPER",
            "name": "YTW",
            "identifier": "017",
            "level": 3
        }
    ],
    "MF": [
        {
            "category": "MF",
            "movement_type": "FULL",
            "name": "BEAR",
            "identifier": "010",
            "level": 9
        },
        {
            "category": "MF",
            "movement_type": "FULL",
            "name": "BURPEES",
            "identifier": "001",
            "level": 8
        },
        {
            "category": "MF",
            "movement_type": "FULL",
            "name": "HIGH JUMPS",
            "identifier": "011",
            "level": 8
        },
        {
            "category": "MF",
            "movement_type": "FULL",
            "name": "LATERAL JUMPS",
            "identifier": "005",
            "level": 8
        },
        {
            "category": "MF",
            "movement_type": "FULL",
            "name": "REVERSE PLANK",
            "identifier": "003",
            "level": 8
        },
        {
            "category": "MF",
            "movement_type": "FULL",
            "name": "SIDE PLANK L",
            "identifier": "008",
            "level": 8
        },
        {
            "category": "MF",
            "movement_type": "FULL",
            "name": "SIDE PLANK R",
            "identifier": "009",
            "level": 8
        },
        {
            "category": "MF",
            "movement_type": "FULL",
            "name": "SIT-OUTS",
            "identifier": "002",
            "level": 8
        },
        {
            "category": "MF",
            "movement_type": "FULL",
            "name": "V UP",
            "identifier": "004",
            "level": 9
        },
        {
            "category": "MF",
            "movement_type": "FULL",
            "name": "WINDMILLS L",
            "identifier": "006",
            "level": 6
        },
        {
            "category": "MF",
            "movement_type": "FULL",
            "name": "WINDMILLS R",
            "identifier": "007",
            "level": 6
        },
        {
            "category": "MF",
            "movement_type": "UPPER",
            "name": "CHAIR DIPS",
            "identifier": "017",
            "level": 8
        },
        {
            "category": "MF",
            "movement_type": "UPPER",
            "name": "DIVE BOMBER PUSHUPS",
            "identifier": "013",
            "level": 7
        },
        {
            "category": "MF",
            "movement_type": "UPPER",
            "name": "GRASSHOPPER PUSHUPS",
            "identifier": "016",
            "level": 6
        },
        {
            "category": "MF",
            "movement_type": "UPPER",
            "name": "INCHWORMS",
            "identifier": "020",
            "level": 7
        },
        {
            "category": "MF",
            "movement_type": "UPPER",
            "name": "PLANK",
            "identifier": "014",
            "level": 8
        },
        {
            "category": "MF",
            "movement_type": "UPPER",
            "name": "PUSHUPS",
            "identifier": "012",
            "level": 7
        },
        {
            "category": "MF",
            "movement_type": "UPPER",
            "name": "ROW AND FLY",
            "identifier": "019",
            "level": 6
        },
        {
            "category": "MF",
            "movement_type": "UPPER",
            "name": "Superman",
            "identifier": "018",
            "level": 6
        },
        {
            "category": "MF",
            "movement_type": "UPPER",
            "name": "YTWS",
            "identifier": "015",
            "level": 5
        },
        {
            "category": "MF",
            "movement_type": "LOWER",
            "name": "CURTSY TWIST",
            "identifier": "029",
            "level": 6
        },
        {
            "category": "MF",
            "movement_type": "LOWER",
            "name": "DRINKING BIRD L",
            "identifier": "024",
            "level": 8
        },
        {
            "category": "MF",
            "movement_type": "LOWER",
            "name": "DRINKING BIRD R",
            "identifier": "025",
            "level": 8
        },
        {
            "category": "MF",
            "movement_type": "LOWER",
            "name": "FROG DEADLIFT",
            "identifier": "031",
            "level": 5
        },
        {
            "category": "MF",
            "movement_type": "LOWER",
            "name": "GLUTE BRIDGE",
            "identifier": "030",
            "level": 10
        },
        {
            "category": "MF",
            "movement_type": "LOWER",
            "name": "JUMP LUNGES",
            "identifier": "026",
            "level": 8
        },
        {
            "category": "MF",
            "movement_type": "LOWER",
            "name": "JUMP SQUATS",
            "identifier": "021",
            "level": 6
        },
        {
            "category": "MF",
            "movement_type": "LOWER",
            "name": "ONE LEG SQUATS",
            "identifier": "027",
            "level": 7
        },
        {
            "category": "MF",
            "movement_type": "LOWER",
            "name": "SIDE LUNGE",
            "identifier": "028",
            "level": 6
        },
        {
            "category": "MF",
            "movement_type": "LOWER",
            "name": "SPLIT SQUAT L",
            "identifier": "022",
            "level": 6
        },
        {
            "category": "MF",
            "movement_type": "LOWER",
            "name": "SPLIT SQUAT R",
            "identifier": "023",
            "level": 6
        }
    ]
}

export const workoutPlaylistImages = [
    'WM20001-Workout-Thumbnail.jpg',
    'WM20002-Workout-Thumbnail.jpg',
    'WM20003-Workout-Thumbnail.jpg',
    'WM20004-Workout-Thumbnail.jpg',
    'WM20005-Workout-Thumbnail.jpg',
    'WM20006-Workout-Thumbnail.jpg',
    'WM20007-Workout-Thumbnail.jpg',
    'WM20008-Workout-Thumbnail.jpg'
];

export const WorkoutAudio = {
    intro: [
        {
            source: `assets/audio/workout-demo/Intro.mp3`,
            type: 'audio/mpeg',
            selected: false
        }
    ],
    warmup: [
        {
            source: `assets/audio/workout-demo/Mellow1.mp3`,
            type: 'audio/mpeg',
            selected: false
        },
        {
            source: `assets/audio/workout-demo/Mellow2.mp3`,
            type: 'audio/mpeg',
            selected: false
        },
        {
            source: `assets/audio/workout-demo/Mellow3.mp3`,
            type: 'audio/mpeg',
            selected: false
        }
    ],
    block: [
        {
            source: `assets/audio/workout-demo/Upbeat1.mp3`,
            type: 'audio/mpeg',
            selected: false
        },
        {
            source: `assets/audio/workout-demo/Upbeat2.mp3`,
            type: 'audio/mpeg',
            selected: false
        },
        {
            source: `assets/audio/workout-demo/Upbeat3.mp3`,
            type: 'audio/mpeg',
            selected: false
        },
        {
            source: `assets/audio/workout-demo/Upbeat4.mp3`,
            type: 'audio/mpeg',
            selected: false
        },
        {
            source: `assets/audio/workout-demo/Upbeat5.mp3`,
            type: 'audio/mpeg',
            selected: false
        },
        {
            source: `assets/audio/workout-demo/Upbeat6.mp3`,
            type: 'audio/mpeg',
            selected: false
        },
        {
            source: `assets/audio/workout-demo/Upbeat7.mp3`,
            type: 'audio/mpeg',
            selected: false
        }
    ]
};